module.exports = __webpack_public_path__ + "static/knittedstarstripehamper-eaf6965f391a35e1f0a3cdb861279a91.jpeg";